import { useState } from "react";
import {
  IEditStatusEmailValues,
  IImagePreviews,
  IEditStatusEmail,
} from "../../interfaces/order";
import { Grid, IconButton, Box, Typography } from "@mui/material";
import ConfirmChangesButtons from "../configuration/ConfirmChangesButtons";
import { updateEmailTemplate } from "../../requests/orderRequests";
import { IAlert } from "../../interfaces/alert";
import { ERROR } from "../../utils/constants";
import GenericAlert from "../GenericAlert";
import ModalBase from "../modals/ModalBase";
import ViewStatusEmail from "./ViewStatusEmail";
import { parseFormData } from "../../utils/emailFormData";
import {
  LogoSection,
  BannerSection,
  DescriptionSection,
  FooterSection,
} from "./EmailEditorSections";

const EditStatusEmail = (props: IEditStatusEmail) => {
  const { template, status, setOpen, fetchEmailTemplates, footer } = props;
  const [currentValues, setCurrentValues] = useState<IEditStatusEmailValues>({
    footerEnabled: footer?.enabled,
    footerContent: footer?.content || "",
  } as IEditStatusEmailValues);
  const [openPreview, setOpenPreview] = useState(false);
  const [imagePreviews, setImagePreviews] = useState<IImagePreviews>(
    {} as IImagePreviews
  );
  const [alert, setAlert] = useState({} as IAlert);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setCurrentValues({} as IEditStatusEmailValues);
  };

  const handleConfirmChanges = async () => {
    setLoading(true);
    const formData = parseFormData({
      ...currentValues,
      status: status.id,
      footer: JSON.stringify({
        enabled: currentValues.footerEnabled,
        content: currentValues.footerContent,
      }),
    } as IEditStatusEmailValues);

    try {
      await updateEmailTemplate(formData);
      handleClose();
      await fetchEmailTemplates();
    } catch (error: unknown) {
      setAlert({ typeOfAlert: ERROR, message: String(error), showAlert: true });
    } finally {
      setLoading(false);
    }
  };

  const handleUploadedFilePreview = (id: string, file: File | Blob) => {
    const reader = new FileReader();
    reader.onload = () => {
      setImagePreviews((prev) => ({ ...prev, [id]: reader.result }));
    };
    reader.readAsDataURL(file);
  };

  const sectionProps = {
    currentValues,
    setCurrentValues,
    template,
    imagePreviews,
    handleUploadedFilePreview,
  };

  return (
    <>
      <ModalBase open={openPreview} handleClose={() => setOpenPreview(false)}>
        <Grid>
          <ViewStatusEmail
            status={status}
            template={{
              banner_url: imagePreviews.banner || template?.banner_url || "",
              logo_url: imagePreviews.logo || template?.logo_url || "",
              description:
                currentValues.description || template?.description || "",
            }}
            footer={{
              enabled: !!currentValues.footerEnabled,
              content: currentValues.footerContent,
            }}
          />
        </Grid>
      </ModalBase>
      <Grid item xs={12}>
        <Typography fontSize={20} mb={2}>
          Editar correo en estado {status.label}
        </Typography>
      </Grid>
      {alert.showAlert && (
        <Grid item xs={12} mb={2}>
          <GenericAlert alert={alert} />
        </Grid>
      )}
      <Grid item xs={12} mb={3}>
        <Box display="flex" justifyContent="space-between">
          <Typography fontSize={20} mb={1}>
            Marca
          </Typography>
          <IconButton
            size="small"
            color="primary"
            onClick={() => setOpenPreview(true)}
          >
            <span className="material-symbols-rounded">visibility</span>
          </IconButton>
        </Box>
      </Grid>
      <LogoSection {...sectionProps} />
      <BannerSection {...sectionProps} />
      <DescriptionSection {...sectionProps} />
      <FooterSection {...sectionProps} />
      <ConfirmChangesButtons
        handleCancel={handleClose}
        handleConfirm={handleConfirmChanges}
        disableConfirmButton={loading || !Object.keys(currentValues).length}
        size={6}
      />
    </>
  );
};

export default EditStatusEmail;
